import React, { createContext, useContext, useState, ReactNode } from 'react';
import { Trial } from '../types';

export type TrialsContextType = {
  trials: Trial[];
  setTrials: (trials: Trial[]) => void;
};

const TrialsContext = createContext<TrialsContextType>({
  trials: [],
  setTrials: () => {},
});

export const TrialsProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [trials, setTrials] = useState<Trial[]>([]);

  return <TrialsContext.Provider value={{ trials, setTrials }}>{children}</TrialsContext.Provider>;
};

export const useTrials = () => useContext(TrialsContext);
